import React, { Component } from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import Section from './Section.js'

class Start extends Component {

    render() {
        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center" >
                        <div className="header-img" >
                            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
                        </div>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form className="pvc-form">
                            <div className="text-center">
                                <h3 style={{color: '#000'}}>Estás a un paso de solicitar la Tarjeta Mastercard</h3>
                                <div style={{margin: '40px 0'}}>
                                    <img
                                        alt="Tarjeta Mastercard"
                                        src={require(`../assets/${process.env.PAGE}/img/tarjeta-mastercard.png`)}
                                        style={{maxWidth: '300px', width: '100%'}}
                                    />
                                </div>
                                <h4 style={{color: '#555', marginBottom: '30px'}}>
                                    Durante los siguientes pasos te solicitaremos información y documentación para finalizar el trámite
                                </h4>
                                <button
                                    type="button"
                                    className="btn btn-warning btn-lg pd-button pd-form"
                                    onClick={this.props.sentStart}
                                >
                                  Seguir
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

Start = withAuthControl(Start);

export default Start;



/** WEBPACK FOOTER **
 ** ./src/components/Start.js
 **/